import { ELITE_SECTION_NAMES } from "../../constants/luxury-cars-constants";

export const parseLuxuryCarsCmsData = (data) => {
    let landingBanner = {};
    const otherSections = [];
    if (data && data.pageSections) {
        for (let i = 0; i < data.pageSections.length; i++) {
            const section = data.pageSections[i];
            if (section.pageSection.name === ELITE_SECTION_NAMES.ELITE_LANDING_PAGE_TOP || section.pageSection.name === ELITE_SECTION_NAMES.ELITE_LANDING_PAGE_DSTP) {
                landingBanner = section.pageSection;
            } else {
                otherSections.push(section);
            }
        }
    }

    return {
        landingBanner,
        otherSections,
        seo: data?.seo?.[0] || {}
    };
};
